import Cookie from "js-cookie";

/**
 * One-shot cleanup of stale legacy auth cookies left over from before
 * DSP-1477's Auth0-only rollout. Safe to call on every app boot — js-cookie
 * silently no-ops when the cookie is absent. Remove this helper one release
 * after the rollout when every active session has run it at least once.
 *
 * Cleanup tracked in DSP-1825: https://remerge.atlassian.net/browse/DSP-1825
 */
export function clearStaleLegacyCookies(): void {
  if (typeof window === "undefined") return;

  const baseDomain = window.location.hostname.endsWith(".remerge.io") ? "remerge.io" : "remerge.test";

  // The legacy writers in shared/auth/sso-state.ts and shared/http/id-token.ts
  // set the cookies with domain=remerge.{io,test} (no leading dot, value
  // straight from VITE_SSO_COOKIE_DOMAIN). RFC 6265 treats `domain=foo` and
  // `domain=.foo` as equivalent, but js-cookie's removal needs the exact
  // attribute the cookie was set with — so try both forms.
  for (const domain of [baseDomain, `.${baseDomain}`]) {
    Cookie.remove("auth_type", { path: "/", domain });
    Cookie.remove("id_token", { path: "/", domain });
  }
}
